import { ThemeProvider } from "@mui/system";
// import { theme } from "./Customization/Theme";
import RootNavigator from "./Routes/RootNavigator";
import { Provider } from "react-redux";
import CustomSnackbarProvider from "./Hooks/useNotification/CustomSnackbarProvider";
import store from "./Store";
import { useAppSelector } from "./Store";
import { useAuthStore } from "./Store/Slices/AuthSlice";
import { createDynamicTheme } from "./Customization/DynamicTheme";
import { validateToken } from "./Utils/Utils";
import TestApp from "./ThemedApp";
import ThemedApp from "./ThemedApp";
validateToken();



const App = () => {
  // const { primaryColor, secondaryColor } = useAppSelector((state) => state.theme);

  return (
    <Provider store={store}>
      <ThemedApp  />
    </Provider>
  );
};

export default App;
